import React, { useContext } from 'react'
import classNames from 'classnames'
import { FlexColumn } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { AsP, EyebrowXS, Text } from '@/atoms/Text'
import { ExperimentVariation, GBFadeInExperiment } from '@/experimentation'
import { LimitedDateModalContext } from '@/views/TicketCheckoutViews/ShowtimesView/contexts/LimitedDateModalContext'

interface LimitedDateCardProps {
  onClick?: () => void
}

export const LimitedDateCard: React.FC<LimitedDateCardProps> = () => {
  const limitedDateModalContext = useContext(LimitedDateModalContext)

  const handleClick = () => {
    limitedDateModalContext.openModal()
  }
  return (
    <div
      className="relative h-24 w-[72px] cursor-pointer overflow-hidden rounded-xl border border-[#F45A3B]"
      onClick={handleClick}
    >
      <div
        className="absolute inset-0 bg-white"
        style={{
          background: 'linear-gradient(149.6deg, rgba(244, 90, 59, 0) 0%, rgba(244, 90, 59, 0.1) 100%)',
        }}
      ></div>
      <div className="absolute top-[calc(100%-80px)]">
        <Image src="/v1749437195/sketch/Num.webp" alt="" width={68} height={60} />
      </div>
      <FlexColumn className={'relative h-full items-center justify-center'}>
        <div className="relative flex h-[20px] w-full flex-col items-center justify-center text-center">
          <div className="flex  flex-col justify-center pt-0.5 text-center">
            <Text
              as={AsP}
              weight="normal"
              className={classNames(
                '!text-xl !leading-[1.125] !font-nomadic bg-clip-text text-transparent',
                '!bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.25)_100%),linear-gradient(0deg,#F45A3B,#F45A3B)]',
              )}
            >
              Guild
            </Text>
          </div>
        </div>
        <GBFadeInExperiment experimentName="sketch-red-carpet-card" defaultValue={false}>
          <ExperimentVariation variation={true}>
            <div className="relative flex w-full  cursor-pointer flex-col items-center justify-center pt-0.5 text-center">
              <EyebrowXS weight={'medium'} color={'core-gray-700'} className={'cursor-pointer tracking-[1px] '}>
                Red
              </EyebrowXS>
              <EyebrowXS weight={'medium'} color={'core-gray-700'} className={'cursor-pointer tracking-[1px] '}>
                carpet
              </EyebrowXS>
            </div>
          </ExperimentVariation>
          <ExperimentVariation default>
            <div className="relative flex w-full  cursor-pointer flex-col items-center justify-center pt-0.5 text-center">
              <EyebrowXS weight={'medium'} color={'core-gray-700'} className={'cursor-pointer tracking-[1px] '}>
                only
              </EyebrowXS>
              <EyebrowXS weight={'medium'} color={'core-gray-700'} className={'cursor-pointer tracking-[1px] '}>
                Premiere
              </EyebrowXS>
            </div>
          </ExperimentVariation>
        </GBFadeInExperiment>
      </FlexColumn>
    </div>
  )
}
